export const LLM_COLORS = {
  chatgpt: {
    bg: "bg-green-500/20",
    text: "text-green-600",
    border: "border-green-500/30",
    label: "ChatGPT",
  },
  gemini: {
    bg: "bg-blue-500/20",
    text: "text-blue-600",
    border: "border-blue-500/30",
    label: "Gemini",
  },
  claude: {
    bg: "bg-orange-500/20",
    text: "text-orange-600",
    border: "border-orange-500/30",
    label: "Claude",
  },
};
